export interface ID3Data {
    label: string;
    value: number;
}
